import { render } from "./Request.vue?vue&type=template&id=4dba9f40&scoped=true"
import script from "./Request.vue?vue&type=script&lang=js"
export * from "./Request.vue?vue&type=script&lang=js"

import "./Request.vue?vue&type=style&index=0&id=4dba9f40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4dba9f40"

export default script